export const isLoadingSelector = state => state.app.isLoading;
export const modalSelector = state => state.app.modal;
export const isDashboardLoadedSelector = state => state.app.isDashboardLoaded;
export const authErrorSelector = state => state.app?.authError;
